import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ToolbarModule } from 'primeng/toolbar';
import { ButtonModule } from 'primeng/button';
import { HrFormButtonsComponent } from './hr-form-buttons.component';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
    declarations: [HrFormButtonsComponent],
    imports: [CommonModule, ToolbarModule, ButtonModule, TranslateModule],
    exports: [HrFormButtonsComponent],
})
export class HrFormButtonsModule {}
